import apiClient from '../apiClient';

export const getAdminDashboard = async (oemId, scanType) => {
  const response = await apiClient.get(`/admin/dashboard/data?oemId=${oemId}&scanType=${scanType}`);
  return response.data;
};
